import React, { useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../common/components/AddToMergeListButton";
import { ManageAncillaryContext } from "../../context/ManageAncillaryContext";
import { AncillaryItem } from "../AncillaryItem";
import { canBeAddedToMergeList } from "../utils/canBeAddedToMergeList";

export const AddAncillaryToMergeButton: React.FC<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const { ancillaryItems, ancillariesToMerge, addAncillaryToMerge } = useContext(ManageAncillaryContext);

    const itemToMerge = ancillaryItems.find((ancillary: AncillaryItem) => ancillary.id === props.itemId);

    if (!itemToMerge) {
        throw new Error("Could not find ancillary to merge on ancillary list.");
    }

    const isButtonDisabled =
        ancillariesToMerge.map((ancillary) => ancillary.id).includes(itemToMerge.id) ||
        !canBeAddedToMergeList(ancillariesToMerge, itemToMerge);

    return <AddToMergeListButton disabled={isButtonDisabled} onClick={() => addAncillaryToMerge(itemToMerge)} />;
};
